// extracted by mini-css-extract-plugin
export default {"number":"order-modal_number__vfKqS"};